import React, { FC } from 'react';
import CreatedReviewDates from '@components/EntityDrawers/components/inputs/CreatedReviewDates';
import DescriptionInput from '@components/EntityDrawers/components/inputs/DescriptionInput';
import DomainDropdown from '@components/EntityDrawers/components/inputs/DomainDropdown/DomainDropdown';
import NameInput from '@components/EntityDrawers/components/inputs/NameInput';
import OwnersInput from '@components/EntityDrawers/components/inputs/OwnersInput';
import DateIdentifiedInput from '@components/EntityDrawers/drawers/Risk/inputs/DateIdentifiedInput';
import StewardJustificationNoteInput from '@components/EntityDrawers/drawers/Risk/inputs/StewardJustificationNoteInput';
import TaxonomyDropdown from '@components/EntityDrawers/drawers/Risk/inputs/TaxonomyDropdown';
import { RiskKeys } from '@components/EntityDrawers/drawers/Risk/keys';
import { useDrawerContext } from '@components/EntityDrawers/providers/DrawerProvider';
import EntityAlerts from '@views/Project/components/EntityAlerts';

import StewardsOpinionDropdown from '../inputs/StewardsOpinionDropdown';

const General: FC = () => {
  const { editMode } = useDrawerContext();

  return (
    <>
      <EntityAlerts />

      <NameInput
        label="Risk name"
        placeholder="Risk name"
        editMode={editMode}
      />

      <DescriptionInput
        label="Risk description"
        placeholder="Risk description"
      />

      <TaxonomyDropdown />
      <DomainDropdown variant="targetOnly" disabled />

      <OwnersInput label="Risk owner" placeholder="Risk owner" />

      <OwnersInput
        name={RiskKeys.Assessor}
        label="Risk assessor"
        placeholder="Risk assessor"
      />

      <OwnersInput
        name={RiskKeys.Steward}
        label="Risk steward"
        placeholder="Risk steward"
        required={false}
      />

      <StewardsOpinionDropdown />
      <StewardJustificationNoteInput />
      <DateIdentifiedInput />

      {editMode && (
        <CreatedReviewDates reviewValidateOnBlur dateReviewedClearable />
      )}
    </>
  );
};

export default General;
